import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState:any = {}

const giftCardProducts = createSlice({
  name: 'giftCardProducts',
  initialState,
  reducers: {
    setGiftCardProducts(state,action:PayloadAction<any>){
        return (state = action.payload)
    }
  },

});

// Reducer
export default giftCardProducts.reducer;

// Actions
export const {setGiftCardProducts} = giftCardProducts.actions;

